import { System } from 'src/app/@framework/core/clms.fw.dotnet';
import * as Domain from '../Domain';
import * as Common from '../../@framework/common';
import { CLMS  } from 'src/app/@framework/core/clms.fw.common';
import { Joove } from 'src/app/@framework/core/Joove';
import * as moment from 'moment';
import { TranslateService } from '@ngx-translate/core';
import { DataListColumnInfo, DataListColumnItemType, ListDynamicColumnValue } from '@framework/components/DataList/helpers/List.helper.classes';
import { ValueFormat } from '@framework/core/clms.fw.angular';
var numeral = require('numeral');
const VerEx = require('verbal-expressions');


export class EmbedConfigSettings  {
    _originalTypeClassName = "zERP.BO.EmbedConfigSettings";
constructor(protected translateService: TranslateService = null) {
if (translateService != null) {
EmbedConfigSettings.translate = translateService;
}
this.panes = new Domain.EmbedConfigPanes();
this.EmbedConfigSettingsKey = null;
this._key = this.EmbedConfigSettingsKey = 0; 
}

static translate: TranslateService;
_key: any;
panes:any;
private _EmbedConfigSettingsKey:any;
get EmbedConfigSettingsKey(): any {
    return this._EmbedConfigSettingsKey;
  }
set EmbedConfigSettingsKey(value: any) {
    this._EmbedConfigSettingsKey = value;
    this._key = value;
  }
static setpanes = ($this, value) => {
var oldValue = $this.panes;
$this.panes = value;
if (value != null) {
}
}


static IsNew($this: any): boolean {
                if ($this == null) return true;
                return $this.EmbedConfigSettingsKey == null || $this.EmbedConfigSettingsKey == 0;
            }


}